function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#ffaf00}");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M303.5 0A159.7 159.7 0 00144 159.5c0 36.2 12.1 69.6 32.5 96.4l-32.3 32.3-.6.6a38.9 38.9 0 00-36 10.8l-96 96C4.1 403 0 412.9 0 423.5s4.1 20.5 11.6 27.9C19 458.9 29 463 39.5 463s20.5-4.1 27.9-11.6l96-96a39.2 39.2 0 0010.8-36l.6-.6 32.3-32.3a158.6 158.6 0 0096.4 32.5c87.9 0 159.5-71.6 159.5-159.5S391.4 0 303.5 0zM56.8 440.8a24.5 24.5 0 11-34.6-34.6l86.7-86.7 34.6 34.6-86.7 86.7zm97.3-97.3L119.6 309a24.7 24.7 0 0116-5.9 24.5 24.5 0 0124.5 24.5 25.3 25.3 0 01-6 15.9zm13.6-38.8a41.5 41.5 0 00-9.4-9.4l27.8-27.8c3 3.3 6.1 6.4 9.4 9.4l-27.8 27.8zm135.8-.7C223.8 304 159 239.2 159 159.5S223.8 15 303.5 15 448 79.8 448 159.5 383.2 304 303.5 304z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M303.5 32C233.2 32 176 89.2 176 159.5S233.2 287 303.5 287 431 229.8 431 159.5 373.8 32 303.5 32zm0 240c-62 0-112.5-50.5-112.5-112.5S241.5 47 303.5 47 416 97.5 416 159.5 365.5 272 303.5 272z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M355.6 79.4a7.5 7.5 0 00-10.4 2.2 7.5 7.5 0 002.2 10.4 80.3 80.3 0 0118.2 118.7 7.6 7.6 0 001 10.6 7.2 7.2 0 004.8 1.7c2.2 0 4.3-.9 5.8-2.7a95.4 95.4 0 00-21.6-140.9zM320.9 65.6c-5.7-1-11.5-1.6-17.4-1.6-4.1 0-7.5 3.4-7.5 7.5s3.4 7.5 7.5 7.5c4.9 0 9.8.4 14.6 1.3l1.4.1c3.5 0 6.7-2.5 7.4-6.1.7-4.1-2-8-6-8.7z"
});

var SvgSearch = function SvgSearch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: 0,
    y: 0,
    viewBox: "0 0 463 463",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search.d0eb95a1.svg";
export { ForwardRef as ReactComponent };